import LoginPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/LoginPage";
import { getDefaultModalUI } from "components/custom-ui/CustomModal/components/FirstTimeLoginModal";
import { BCMSStateManagerCRUD } from "bcms-react";

/**
 * @name CaptureFirstLoginTextSent
 * @returns {React.Component}
 * @description Capture component for the login page showing the user and password
 * fields filled. And the second step of the first time login modal showing
 */
export default function CaptureFirstLoginTextSent(props) {
    const modalUI = getDefaultModalUI();
    // Initalize a new BCMSStateManagerCRUD using the default page data
    // setting the user id and password properties
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "userID" ], "DemoUser")
        .update([ "password" ], "123456789")
        .submit();
    // initalize a new BCMSStateManagerCRUD instance using the default page ui
    // updating the modal property
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "modal", "id" ], "FirstTimeLoginModal")
        .update([ "modal", "data" ], { ui: { ...modalUI, step: 1 }})
        .submit();

    return <LoginPage data={ data } ui={ ui } />
}